import { h } from 'preact';
import { useState } from 'preact/hooks';
import { objectToInlineStyles } from 'utilities/transform';
import Markup from "preact-markup";

const commonStyles = {
    width: '100%',
    height: '100%',
    position: 'fixed',
    left: 0,
    top: 0,
    margin: 0,
    padding: 0,
    zIndex: 1
};

const commonMessageStyles = {
    color: '#bdbdbd',
    textAlign: 'center',
    color: '#bdbdbd',
    fontFamily: 'sans-serif',
    fontSize: '36px'
};

const PreviewImage = ({ url, onClick = () => {}, playButton = false }) => {
    const [buttonStyleLoaded, setLoaded] = useState(!playButton);
    const style = {
        ...commonStyles,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        cursor: 'pointer',
        backgroundImage: `url(${url})`
    }, 
    className = playButton ? 'vjs-big-play-button' : '';

    if (playButton) {
        if (!buttonStyleLoaded) {
            import('./preview.scss').then(() => setLoaded(true));
            
            return null;
        }

        return (
            <div onClick={ onClick } className="video-js embed-preview" style={ commonStyles }>

                <figure style={ style }/>
                <button className="vjs-big-play-button" style={ { zIndex: 2 } }>
                    <span className="vjs-icon-placeholder"/>
                </button>
            </div>
        )
    }

    return <figure onClick={ onClick } style={ style } />;
};

const PreviewMessage = ({ text = '', additionalStyles = {}, format = '' }) => {
    const message = format === 'richtext' ? <Markup markup={ text } type="html" /> : text;
    const style = {
        ...commonStyles,
        ...commonMessageStyles,
        ...additionalStyles
    };

    return <figure style={ style }> { message } </figure>;
};

const PreviewMessageHTML = ({ text = '' }) => {
    const inlineStyles = objectToInlineStyles(commonMessageStyles);

    return `<h1 style="${inlineStyles}">${text}</h1>`;
}

export { PreviewImage, PreviewMessage, PreviewMessageHTML };